<template>
  <div id="glHouse">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <!--        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>-->
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="display:flex;height:90vh; padding:10px;">
        <div style="width:20vw;padding-left:1vh;padding-right:1vh;background:#FFFFFF;overflow-y:auto;">
          <div style="width:100%;height:6%;display:flex;align-items:center">
            <p>社区管理</p>
            <el-button type="primary" size="small" @click="onAdd('zone')"
                       style="height:36px;margin-left:auto">
              添加社区
            </el-button>
          </div>
          <div class="grid_box" style="height:90%;">
            <div class="grid_item" v-for="d in tabZone">
              <div style="display:flex;height:50px;align-items: center">
                <p style="font-size:17px">{{ d.name }}</p>
                <i @click="onChange('zone',d)" class="el-icon-edit"
                   style="margin-left:auto;color:#5AA3FF;font-size:17px"></i>
                <i @click="onDel('zone',d)" class="el-icon-delete"
                   style="margin-left:15px;color:red;font-size:17px"></i>
              </div>
              <el-button @click="onQh('zone',d)" size="small" style="border-radius:6px">查看片区</el-button>
            </div>
          </div>
        </div>
        <div style="width:20vw;padding-left:1vh;padding-right:1vh;background:#FFFFFF;overflow-y:auto;margin-left:5px">
          <div style="width:100%;height:6%;display:flex;align-items:center">
            <p>小区管理</p>
            <p style="margin-left:1px;width:50%;text-align:center;color:#5AA3FF">{{ xzZoneName }}</p>
            <el-button type="primary" size="small" @click="onAdd('zoneArea')"
                       style="height:36px;margin-left:auto">
              添加小区
            </el-button>
          </div>
          <div class="grid_box" style="height:90%;">
            <div class="grid_item" v-for="d in tabZoneArea">
              <div style="display:flex;height:50px;align-items: center">
                <p style="font-size:17px">{{ d.name }}</p>
                <i @click="onChange('zoneArea',d)" class="el-icon-edit"
                   style="margin-left:auto;color:#5AA3FF;font-size:17px"></i>
                <i @click="onDel('zoneArea',d)" class="el-icon-delete"
                   style="margin-left:15px;color:red;font-size:17px"></i>
              </div>
              <el-button @click="onQh('zoneArea',d)" size="small" style="border-radius:6px">查看楼栋</el-button>
            </div>
          </div>
        </div>
        <div style="width:20vw;padding-left:1vh;padding-right:1vh;background:#FFFFFF;overflow-y:auto;margin-left:5px">
          <div style="width:100%;height:6%;display:flex;align-items:center">
            <p>楼栋管理</p>
            <p style="margin-left:1px;width:50%;text-align:center;color:#5AA3FF">{{ xzZoneAreaName }}</p>
            <el-button type="primary" size="small" @click="onAdd('building')"
                       style="height:36px;margin-left:auto">
              添加楼栋
            </el-button>
          </div>
          <div class="grid_box" style="height:90%;">
            <div class="grid_item" v-for="d in tabZoneBuilding">
              <div style="display:flex;height:50px;align-items: center">
                <p style="font-size:17px">{{ d.name }}</p>
                <i @click="onChange('building',d)" class="el-icon-edit"
                   style="margin-left:auto;color:#5AA3FF;font-size:17px"></i>
                <i @click="onDel('building',d)" class="el-icon-delete"
                   style="margin-left:15px;color:red;font-size:17px"></i>
              </div>
              <el-button @click="onQh('building',d)" size="small" style="border-radius:6px">查看单元</el-button>
            </div>
          </div>
        </div>
        <div style="width:20vw;padding-left:1vh;padding-right:1vh;background:#FFFFFF;overflow-y:auto;margin-left:5px">
          <div style="width:100%;height:6%;display:flex;align-items:center">
            <p>单元管理</p>
            <p style="margin-left:1px;width:50%;text-align:center;color:#5AA3FF">{{ xzBuildingName }}</p>
            <el-button type="primary" size="small" @click="onAdd('unit')"
                       style="height:36px;margin-left:auto">
              添加单元
            </el-button>
          </div>
          <div class="grid_box" style="height:90%;">
            <div class="grid_item" v-for="d in tabZoneUnit">
              <div style="display:flex;height:50px;align-items: center">
                <p style="font-size:17px">{{ d.name }}</p>
                <i @click="onChange('unit',d)" class="el-icon-edit"
                   style="margin-left:auto;color:#5AA3FF;font-size:17px"></i>
                <i @click="onDel('unit',d)" class="el-icon-delete"
                   style="margin-left:15px;color:red;font-size:17px"></i>
              </div>
              <el-button @click="onQh('unit',d)" size="small" style="border-radius:6px">查看房间</el-button>
            </div>
          </div>
        </div>
        <div style="width:20vw;padding-left:1vh;padding-right:1vh;background:#FFFFFF;overflow-y:auto;margin-left:5px">
          <div style="width:100%;height:6%;display:flex;align-items:center">
            <p>房间管理</p>
            <p style="margin-left:1px;width:50%;text-align:center;color:#5AA3FF">{{ xzUnitName }}</p>
            <el-button type="primary" size="small" @click="onAdd('room')"
                       style="height:36px;margin-left:auto">
              添加房间
            </el-button>
          </div>
          <div class="grid_box" style="height:90%;">
            <div class="grid_item" v-for="d in tabZoneRoom">
              <div style="display:flex;height:50px;align-items: center">
                <p style="font-size:17px">{{ d.name }}</p>
                <i @click="onChange('room',d)" class="el-icon-edit"
                   style="margin-left:auto;color:#5AA3FF;font-size:17px"></i>
                <i @click="onDel('room',d)" class="el-icon-delete"
                   style="margin-left:15px;color:red;font-size:17px"></i>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-dialog title='批量添加房间' center :close-on-click-modal="false"
               width="460px" class="dialogApp"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiAddRoom'> <!--v-draggable 拖动-->
      <div style="margin-top:0px">
        <p style="font-size:15px;margin:0;color:#2269DD">说明：房间号由楼层+房号生成，如1-1层，房号1-2</p>
        <p style="font-size:15px;margin:0;padding-left:45px;color: #2269DD">生成房间号为101,102</p>
        <div style="display: flex;align-items: center;margin-top:10px">
          <span style="margin-left:0px;color:#000000; font-size:13px">楼层：</span>
          <el-input-number v-model="edi_floor1" :step="1" :min="1" :max="300" :controls="false"
                           style="margin-left:13px; width:160px;color:#000000;font-size: 15px"></el-input-number>
          <span style="margin-left:0px;color:#000000;width:20px; text-align:center;font-size:13px">-</span>
          <el-input-number v-model="edi_floor2" :step="1" :min="1" :max="300" :controls="false"
                           style="margin-left:0px; width:160px;color:#000000;font-size: 15px"></el-input-number>
        </div>
        <div style="display: flex;align-items: center;margin-top:6px">
          <span style="margin-left:0px;color:#000000; font-size:13px">房号：</span>
          <el-input-number v-model="edi_room1" :step="1" :min="1" :max="300" :controls="false"
                           style="margin-left:13px; width:160px;color:#000000;font-size: 15px"></el-input-number>
          <span style="margin-left:0px;color:#000000;width:20px; text-align:center;font-size:13px">-</span>
          <el-input-number v-model="edi_room2" :step="1" :min="1" :max="300" :controls="false"
                           style="margin-left:0px; width:160px;color:#000000;font-size: 15px"></el-input-number>
        </div>
      </div>
      <div style="display:flex;width:100%;margin-top:20px">
        <el-button type="primary" @click="daiAddRoom=false" style="margin-left:auto;margin-right:5px">取消</el-button>
        <el-button type="primary" @click="KeepAdd" style="margin-left:10px;margin-right:0">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title='txtAdd' center :close-on-click-modal="false"
               width="300px" class="dialogApp"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiAdd'> <!--v-draggable 拖动-->
      <div style="display:flex;margin-top:6px">
        <span style="margin-left:0px;color: #000000; font-size: 13px">
          {{ txtAddName }}名称：
          <el-input v-model="edi_name" maxlength="10"
                    style="margin-left:13px; width:160px;color: #000000; font-size: 15px"></el-input>
        </span>
      </div>
      <div style="display:flex;width:100%;margin-top:20px">
        <el-button type="primary" @click="daiAdd=false" style="margin-left:auto;margin-right:5px">取消</el-button>
        <el-button type="primary" @click="KeepAdd" style="margin-left:10px;margin-right:0">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="删除提示"
        :visible.sync="daiDel"
        width="30%">
      <span>确定删除该{{ txtDel }}吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDel = false">取 消</el-button>
        <el-button type="primary" @click=KeepDel>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name:"glHouse",
  data() {
    return {
      h_text:"房屋管理",
      li_h_text:[
        {"text":"房屋管理","colour":"#B7B7B7","pages":""}
      ],
      daiAddRoom:false,
      daiAdd:false,
      daiDel:false,
      txtAdd:"新增小区",
      txtAddName:"小区",
      txtDel:"",
      idZone:0,
      xzZoneId:0,
      xzZoneName:"",
      idZoneArea:0,
      xzZoneAreaId:0,
      xzZoneAreaName:"",
      idBuilding:0,
      xzBuildingId:0,
      xzBuildingName:"",
      idUnit:0,
      xzUnitId:0,
      xzUnitName:"",
      idRoom:0,
      xzRoomId:0,
      xzRoomName:"",
      edi_name:"",
      edi_floor1:1,
      edi_floor2:3,
      edi_room1:1,
      edi_room2:2,
      tabZone:[],
      tabZoneArea:[],
      tabZoneBuilding:[],
      tabZoneUnit:[],
      tabZoneRoom:[],
      li_zoom:[],
      li_zoomArea:[],
      li_zoomBuilding:[],
      li_zoomUnit:[],
      li_zoomRoom:[],
      pageZoon:1,
      pageSizeZoon:30,
      totalZoon:30,
      pageZoneArea:1,
      pageSizeZoneArea:30,
      totalZoneArea:30,
      pageBuilding:1,
      pageSizeBuilding:30,
      totalBuilding:30,
      pageUnit:1,
      pageSizeUnit:30,
      totalUnit:30,
      pageRoom:1,
      pageSizeRoom:30,
      totalRoom:30
    };
  },
  methods:{ /*方法存放*/
    onAdd(name) {
      let is_show = true;
      switch (name) {
        case 'zone':
          this.txtAdd = "添加社区";
          this.txtAddName = "社区";
          break;
        case 'zoneArea':
          if (this.xzZoneId === 0) {
            is_show = false;
            this.$message.info("请先选择社区");
          }
          this.txtAdd = "添加小区";
          this.txtAddName = "小区";
          break;
        case 'building':
          if (this.xzZoneAreaId === 0) {
            is_show = false;
            this.$message.info("请先选择小区");
          }
          this.txtAdd = "添加楼栋";
          this.txtAddName = "楼栋";
          break;
        case 'unit':
          if (this.xzBuildingId === 0) {
            is_show = false;
            this.$message.info("请先选择楼栋");
          }
          this.txtAdd = "添加单元";
          this.txtAddName = "单元";
          break;
        case 'room':
          if (this.xzUnitId === 0) {
            is_show = false;
            this.$message.info("请先选择单元");
          } else {
            is_show = false;
            this.txtAdd = "添加房间";
            this.txtAddName = "房间";
            this.daiAddRoom = true;
          }
          break;
      }
      if (is_show) {
        this.daiAdd = true;
      }
    },
    onChange(name,row) {
      switch (name) {
        case 'zone':
          this.idZone = row.id;
          this.edi_name = row.name;
          this.txtAdd = "修改社区";
          this.txtAddName = "社区";
          break;
        case 'zoneArea':
          this.idZoneArea = row.id;
          this.edi_name = row.name;
          this.txtAdd = "修改小区";
          this.txtAddName = "小区";
          break;
        case 'building':
          this.idBuilding = row.id;
          this.edi_name = row.name;
          this.txtAdd = "修改楼栋";
          this.txtAddName = "楼栋";
          break;
        case 'unit':
          this.idUnit = row.id;
          this.edi_name = row.name;
          this.txtAdd = "修改单元";
          this.txtAddName = "单元";
          break;
        case 'room':
          this.idRoom = row.id;
          this.edi_name = row.name;
          this.txtAdd = "修改房间";
          this.txtAddName = "房间";
          break;
      }
      this.daiAdd = true;
    },
    onDel(name,row) {
      switch (name) {
        case 'zone':
          this.txtDel = "社区";
          this.idZone = row.id;
          break;
        case 'zoneArea':
          this.txtDel = "小区";
          this.idZoneArea = row.id;
          break;
        case 'building':
          this.txtDel = "楼栋";
          this.idBuilding = row.id;
          break;
        case 'unit':
          this.txtDel = "单元";
          this.idUnit = row.id;
          break;
        case 'room':
          this.txtDel = "房间";
          this.idRoom = row.id;
          break;
      }
      this.daiDel = true;
    },
    onQh(name,row) {
      switch (name) {
        case 'zone':
          this.xzZoneId = row.id;
          this.xzZoneName = row.name;
          this.li_zoomArea = [];
          this.getZoneAreaList();
          break;
        case 'zoneArea':
          this.xzZoneAreaId = row.id;
          this.xzZoneAreaName = row.name;
          this.li_zoomBuilding = [];
          this.getZoneBuildingList();
          break;
        case 'building':
          this.xzBuildingId = row.id;
          this.xzBuildingName = row.name;
          this.li_zoomUnit = [];
          this.getZoneUnitList();
          break;
        case 'unit':
          this.xzUnitId = row.id;
          this.xzUnitName = row.name;
          this.li_zoomRoom = [];
          this.getZoneRoomList();
          break;
      }
    },
    KeepAdd() {
      const params = {
        'name':this.edi_name,
        'projectId':localStorage.getItem("projectId")
      };
      let urls = "";
      switch (this.txtAdd) {
        case '添加社区':
          urls = this.$urls.addZone;
          break;
        case '修改社区':
          params["id"] = this.idZone;
          urls = this.$urls.updateZone;
          break;
        case '添加小区':
          params["zoneId"] = this.xzZoneId;
          urls = this.$urls.addZoneArea;
          break;
        case '修改小区':
          params["id"] = this.idZoneArea;
          params["zoneId"] = this.xzZoneId;
          urls = this.$urls.updateZoneArea;
          break;
        case '添加楼栋':
          params["zoneAreaId"] = this.xzZoneAreaId;
          urls = this.$urls.addZoneBuilding;
          break;
        case '修改楼栋':
          params["id"] = this.idBuilding;
          params["zoneAreaId"] = this.xzZoneAreaId;
          urls = this.$urls.updateZoneBuilding;
          break;
        case '添加单元':
          params["bulidingId"] = this.xzBuildingId;
          urls = this.$urls.addZoneUnit;
          break;
        case '修改单元':
          params["id"] = this.idUnit;
          params["bulidingId"] = this.xzBuildingId;
          urls = this.$urls.updateZoneUnit;
          break;
        case '添加房间':
          params["unitId"] = this.xzUnitId;
          urls = this.$urls.addZoneRooms;
          let l = [];
          let temp;
          if (this.edi_floor1 > this.edi_floor2) {
            temp = this.edi_floor1;
            this.edi_floor1 = this.edi_floor2;
            this.edi_floor2 = temp;
          }
          if (this.edi_room1 > this.edi_room2) {
            temp = this.edi_room1;
            this.edi_room1 = this.edi_room2;
            this.edi_room2 = temp;
          }
          for (let i = this.edi_floor1; i <= this.edi_floor2; i++) {
            for (let j = this.edi_room1; j <= this.edi_room2; j++) {
              l.push(`${i}${j.toString().padStart(2,'0')}`);
            }
          }
          params['names'] = l;
          break;
        case '修改房间':
          params["id"] = this.idRoom;
          params["unitId"] = this.xzUnitId;
          urls = this.$urls.updateZoneRoom;
          break;
        default:
          break;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + urls,params,headers).then(res => {
        console.log(res.data.data);
        this.daiAdd = false;
        this.daiAddRoom = false;
        switch (this.txtAdd) {
          case '添加社区':
            this.$message.success("添加成功");
            this.li_zoom = [];
            this.getZoneList();
            break;
          case '修改社区':
            this.$message.success("修改成功");
            if (this.xzZoneId === this.idZone) { /*选中等于修改*/
              this.xzZoneName = this.edi_name;
            }
            this.li_zoom = [];
            this.getZoneList();
            break;
          case '添加小区':
            this.$message.success("添加成功");
            this.li_zoomArea = [];
            this.getZoneAreaList();
            break;
          case '修改小区':
            this.$message.success("修改成功");
            if (this.xzZoneAreaId === this.idZoneArea) { /*选中等于修改*/
              this.xzZoneAreaName = this.edi_name;
            }
            this.li_zoomArea = [];
            this.getZoneAreaList();
            break;
          case '添加楼栋':
            this.$message.success("添加成功");
            this.li_zoomBuilding = [];
            this.getZoneBuildingList();
            break;
          case '修改楼栋':
            this.$message.success("修改成功");
            if (this.xzBuildingId === this.idBuilding) { /*选中等于修改*/
              this.xzBuildingName = this.edi_name;
            }
            this.li_zoomBuilding = [];
            this.getZoneBuildingList();
            break;
          case '添加单元':
            this.$message.success("添加成功");
            this.li_zoomUnit = [];
            this.getZoneUnitList();
            break;
          case '修改单元':
            this.$message.success("修改成功");
            if (this.xzUnitId === this.idUnit) { /*选中等于修改*/
              this.xzUnitName = this.edi_name;
            }
            this.li_zoomUnit = [];
            this.getZoneUnitList();
            break;
          case '添加房间':
            this.$message.success("添加成功");
            this.li_zoomRoom = [];
            this.getZoneRoomList();
            break;
          case '修改房间':
            this.$message.success("修改成功");
            this.li_zoomRoom = [];
            this.getZoneRoomList();
            break;
        }
      }).catch(error => {
        this.daiAdd = false;
        this.daiAddRoom = false;
        console.log(error);
        if (error) {
          this.$message.error("操作失败");
        }
      });
    },
    KeepDel() {
      const params = {
        'projectId':localStorage.getItem("projectId")
      };
      let urls = "";
      switch (this.txtDel) {
        case '社区':
          params["id"] = this.idZone;
          urls = this.$urls.delZone;
          break;
        case '小区':
          params["id"] = this.idZoneArea;
          urls = this.$urls.delZoneArea;
          break;
        case '楼栋':
          params["id"] = this.idBuilding;
          urls = this.$urls.delZoneBuilding;
          break;
        case '单元':
          params["id"] = this.idUnit;
          urls = this.$urls.delZoneUnit;
          break;
        case '房间':
          params["id"] = this.idRoom;
          urls = this.$urls.delZoneRoom;
          break;
        default:
          break;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + urls,params,headers).then(res => {
        console.log(res.data.data);
        this.daiDel = false;
        this.$message.success("删除成功");
        switch (this.txtDel) {
          case '社区':
            /*刚好删除选中id*/
            //if (this.xzZoneId === this.idZone) {
            //  this.xzZoneId = 0;
            //  this.xzZoneName = "";
            //}
            this.li_zoom = [];
            this.getZoneList();
            break;
          case '小区':
            this.li_zoomArea = [];
            this.getZoneAreaList();
            break;
          case '楼栋':
            this.li_zoomBuilding = [];
            this.getZoneBuildingList();
            break;
          case '单元':
            this.li_zoomUnit = [];
            this.getZoneUnitList();
            break;
          case '房间':
            this.li_zoomRoom = [];
            this.getZoneRoomList();
            break;
        }
      }).catch(error => {
        this.daiDel = false;
        console.log(error);
        if (error) {
          this.$message.error("删除失败");
        }
      });
    },
    getZoneList() {
      const params = {
        'page':this.pageZoon,
        'pageSize':this.pageSizeZoon,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getZoneList,params,headers).then(res => {
        console.log("getZoneList",res.data.data);
        this.totalZoon = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_zoom;
        for (let i = 0; i < data.length; i++) {
          let d = {
            id:data[i]['id'],
            name:data[i]['name']
          };
          l.push(d);
        }
        this.li_zoom = l;
        if (this.pageZoon * this.pageSizeZoon < this.totalZoon) {
          this.pageZoon += 1;
          this.getZoneList();
        } else {
          this.tabZone = [];
          let l = [];
          for (let i = 0; i < this.li_zoom.length; i++) {
            l.push({
              "id":this.li_zoom[i]["id"],
              "name":this.li_zoom[i]["name"]
            });
          }
          this.tabZone = l;
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    getZoneAreaList() {
      const params = {
        'page':this.pageZoneArea,
        'pageSize':this.pageSizeZoneArea,
        'zoneId':this.xzZoneId,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getZoneAreaList,params,headers).then(res => {
        console.log("getZoneAreaList",res.data.data);
        this.totalZoneArea = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_zoomArea;
        for (let i = 0; i < data.length; i++) {
          let d = {
            id:data[i]['id'],
            name:data[i]['name']
          };
          l.push(d);
        }
        this.li_zoomArea = l;
        if (this.pageZoneArea * this.pageSizeZoneArea < this.totalZoneArea) {
          this.pageZoneArea += 1;
          this.getZoneAreaList();
        } else {
          this.tabZoneArea = [];
          let l = [];
          for (let i = 0; i < this.li_zoomArea.length; i++) {
            l.push({
              "id":this.li_zoomArea[i]["id"],
              "name":this.li_zoomArea[i]["name"]
            });
          }
          this.tabZoneArea = l;
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    getZoneBuildingList() {
      const params = {
        'page':this.pageBuilding,
        'pageSize':this.pageSizeBuilding,
        'zoneAreaId':this.xzZoneAreaId,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getZoneBuildingList,params,headers).then(res => {
        console.log("getZoneBuildingList",res.data.data);
        this.totalBuilding = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_zoomBuilding;
        for (let i = 0; i < data.length; i++) {
          let d = {
            id:data[i]['id'],
            name:data[i]['name']
          };
          l.push(d);
        }
        this.li_zoomBuilding = l;
        if (this.pageBuilding * this.pageSizeBuilding < this.totalBuilding) {
          this.pageBuilding += 1;
          this.getZoneBuildingList();
        } else {
          this.tabZoneBuilding = [];
          let l = [];
          for (let i = 0; i < this.li_zoomBuilding.length; i++) {
            l.push({
              "id":this.li_zoomBuilding[i]["id"],
              "name":this.li_zoomBuilding[i]["name"]
            });
          }
          this.tabZoneBuilding = l;
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    getZoneUnitList() {
      const params = {
        'page':this.pageUnit,
        'pageSize':this.pageSizeUnit,
        'buildingId':this.xzBuildingId,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getZoneUnitList,params,headers).then(res => {
        console.log("getZoneUnitList",res.data.data);
        this.totalUnit = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_zoomUnit;
        for (let i = 0; i < data.length; i++) {
          let d = {
            id:data[i]['id'],
            name:data[i]['name']
          };
          l.push(d);
        }
        this.li_zoomUnit = l;
        if (this.pageUnit * this.pageSizeUnit < this.totalUnit) {
          this.pageUnit += 1;
          this.getZoneUnitList();
        } else {
          this.tabZoneUnit = [];
          let l = [];
          for (let i = 0; i < this.li_zoomUnit.length; i++) {
            l.push({
              "id":this.li_zoomUnit[i]["id"],
              "name":this.li_zoomUnit[i]["name"]
            });
          }
          this.tabZoneUnit = l;
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    getZoneRoomList() {
      const params = {
        'page':this.pageRoom,
        'pageSize':this.pageSizeRoom,
        'unitId':this.xzUnitId,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getZoneRoomList,params,headers).then(res => {
        console.log("getZoneRoomList",res.data.data);
        this.totalRoom = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_zoomRoom;
        for (let i = 0; i < data.length; i++) {
          let d = {
            id:data[i]['id'],
            name:data[i]['name']
          };
          l.push(d);
        }
        this.li_zoomRoom = l;
        if (this.pageRoom * this.pageSizeRoom < this.totalRoom) {
          this.pageRoom += 1;
          this.getZoneRoomList();
        } else {
          this.tabZoneRoom = [];
          let l = [];
          for (let i = 0; i < this.li_zoomRoom.length; i++) {
            l.push({
              "id":this.li_zoomRoom[i]["id"],
              "name":this.li_zoomRoom[i]["name"]
            });
          }
          this.tabZoneRoom = l;
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.getZoneList();
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#glHouse {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.grid_box { /*表格式布局*/
  display: grid;
  grid-template-columns: 99%;
  grid-template-rows: repeat(auto-fill, 100px);
  grid-auto-flow: row; /*改为先列后行 column*/
  column-gap: 10px; /*行列间距*/
  row-gap: 10px;
  /*grid-template-rows: repeat(auto-fill, 300px); !*设置高度限制*!*/
  /*justify-content: center; align-content: center; !*居中显示*!*/
}

.grid_item {
  height: 100px;
  padding-left: 6%;
  padding-right: 6%;
  border-radius: 6px 6px 6px 6px; /* 左上角、右上角、右下角、左下角 */
  background: linear-gradient(to bottom, #F4F4F4, #f2f2f2 50%, #d9d9d9 100%);
  box-shadow: 0 0 6px #F4F4F4, 0 0 10px rgba(0, 0, 0, 0.1) inset;
}

::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}
</style>



// WEBPACK FOOTER //
// src/pages/gls/glHouse.vue